import RestClient from './RestClient'

const ENTRY_POINT = '/item'

export default class ItemService {
  restClient: RestClient
  constructor(restClient: RestClient) {
    this.restClient = restClient
  }

  getGameItems(form: IGameItemRequest): Promise<IPageable<IGameItem>> {
    return this.restClient.post(ENTRY_POINT + '/game_item', form)
  }

  findGameItems(form: IItemSearchForm): Promise<IPageable<IGameItem>> {
    return this.restClient.post(ENTRY_POINT + '/search', form)
  }

  getRollItems(): Promise<IGameItem[]> {
    return this.restClient.get(ENTRY_POINT + '/roll_item')
  }

  requestRoll(rollRequest: IRollRequestInfo): Promise<IRollRequest> {
    return this.restClient.post(ENTRY_POINT + '/request_roll', rollRequest)
  }

  notifySendMoney(rollRequest: IRollRequest): Promise<boolean> {
    return this.restClient.post(ENTRY_POINT + '/notify-roll', rollRequest)
  }

  getExchangeStore(): Promise<IStoreInfo> {
    return this.restClient.get(ENTRY_POINT + '/get-exchange-store')
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/ItemService.ts